<div class="bundle-size-container" [class.selected]="isSelected">
  <div class="bundle-size-text">{{ bundleSizeText }}</div>

  <div class="free-shipping-text">{{ freeShippingText }}</div>
</div>
